var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.b()},[_c('el-progress',{attrs:{"type":_vm.type,"color":_vm.color,"width":_vm.width,"text-inside":"","show-text":_vm.showText,"stroke-width":_vm.strokeWidth,"percentage":_vm.percentage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }